import { usersReducers } from '../reducers'

export const usersRootReducers = {
  users: usersReducers,
}
